/** Security advisor finding from GET/POST /advisors/security. */
export type SecurityFinding = {
  class: string;
  severity: string;
  object: string;
  title: string;
  detail: string;
};

export type SecurityAdvisorReport = {
  scanned_at: string;
  findings: SecurityFinding[];
};

export const SECURITY_FINDING_CLASSES = {
  rlsDisabled: "rls_disabled_on_exposed_table",
  rlsNoPolicy: "rls_enabled_no_policy",
  policyWithoutRls: "policy_exists_rls_disabled",
} as const;

export function findingSeverityVariant(
  severity: string,
): "danger" | "warning" | "secondary" {
  switch (severity.toUpperCase()) {
    case "ERROR":
      return "danger";
    case "WARN":
    case "WARNING":
      return "warning";
    default:
      return "secondary";
  }
}

export function findingHeadline(finding: SecurityFinding): string {
  return `${finding.severity}: ${finding.object} — ${finding.title}`;
}

export function summarizeSecurityScan(findings: SecurityFinding[]): {
  errors: number;
  warnings: number;
  total: number;
} {
  let errors = 0;
  let warnings = 0;
  for (const finding of findings) {
    const sev = finding.severity.toUpperCase();
    if (sev === "ERROR") errors += 1;
    else if (sev === "WARN" || sev === "WARNING") warnings += 1;
  }
  return { errors, warnings, total: findings.length };
}

/** Table name from a schema-qualified object, for linking to Permissions. */
export function tableNameFromObject(object: string): string {
  const i = object.lastIndexOf(".");
  return i >= 0 ? object.slice(i + 1) : object;
}
